/* Percentages represent settled first-view milestones, not network-byte counts. */
(() => {
  const root = document.querySelector('[data-page-loader]');
  const state = root?._wilgoodIntro;
  if (!state?.active || root.hidden) return;
  const bar = root.querySelector('[data-loader-progress]');
  const percent = root.querySelector('[data-loader-percent]');
  const status = root.querySelector('[data-loader-status]');
  let target = 0;
  let shown = 0;
  let frame = 0;
  let completionTimer = 0;
  let exitTimer = 0;
  let deadline = 0;
  let closing = false;
  let partial = false;
  const cleanupTasks = [];
  const paint = () => {
    frame = 0;
    if (!state.active) return;
    shown = Math.min(target, shown + Math.max(1, Math.ceil((target - shown) * .18)));
    root.style.setProperty('--intro-progress', String(shown / 100));
    bar.setAttribute('aria-valuenow', String(shown));
    percent.textContent = String(shown).padStart(2, '0') + '%';
    if (shown < target) frame = requestAnimationFrame(paint);
  };
  const advance = value => {
    if (!state.active || closing) return;
    target = Math.min(100, Math.max(target, value));
    if (!frame) frame = requestAnimationFrame(paint);
  };
  const close = reason => {
    if (!state.active || closing) return;
    closing = true;
    clearTimeout(deadline);
    if (reason !== 'timeout') {
      target = 100;
      shown = 100;
      root.style.setProperty('--intro-progress', '1');
      bar.setAttribute('aria-valuenow', '100');
      percent.textContent = '100%';
    }
    status.textContent = reason === 'ready' ? 'OPENING WEIRGOOD' : 'CONTINUING WITH AVAILABLE CONTENT';
    root.dataset.state = 'leaving';
    exitTimer = setTimeout(() => state.release(reason), 650);
  };
  const waitForImage = image => new Promise(resolve => {
    if (!image) { partial = true; resolve(); return; }
    const done = async () => {
      image.removeEventListener('load', done);
      image.removeEventListener('error', failed);
      try {
        if (typeof image.decode === 'function') await image.decode();
        if (!image.naturalWidth) partial = true;
      } catch { partial = true; }
      resolve();
    };
    const failed = () => { partial = true; image.removeEventListener('load', done); resolve(); };
    cleanupTasks.push(() => {
      image.removeEventListener('load', done);
      image.removeEventListener('error', failed);
    });
    if (image.complete) { done(); return; }
    image.addEventListener('load', done, { once: true });
    image.addEventListener('error', failed, { once: true });
  });
  state.cleanup = () => {
    cancelAnimationFrame(frame);
    clearTimeout(completionTimer);
    clearTimeout(exitTimer);
    clearTimeout(deadline);
    cleanupTasks.forEach(dispose => dispose());
  };
  // The deferred script runs after the page structure has been parsed.
  let settled = 20;
  advance(settled);
  const milestone = (promise, weight) => Promise.resolve(promise).catch(() => { partial = true; }).then(() => {
    settled += weight;
    advance(settled);
  });
  const hero = document.querySelector('[data-visual-hero] .home-hero__backdrop img, [data-visual-hero] .utility-hero__backdrop img');
  const ready = Promise.all([
    milestone(waitForImage(hero), 60),
    milestone(document.fonts?.ready, 20)
  ]);
  const remaining = Math.max(0, 4000 - (performance.now() - state.started));
  deadline = setTimeout(() => close('timeout'), remaining);
  ready.then(() => {
    if (!state.active || closing) return;
    completionTimer = setTimeout(() => close(partial ? 'partial' : 'ready'),
      Math.max(0, 450 - (performance.now() - state.started)));
  });
})();
